((Drupal, drupalSettings, algoliasearch, instantsearch) => {
  Drupal.theme.search_autocomplete_results = ({indexId, hits, sendEvent}) => {
    return hits.map((hit, index) => {
        let resultType = '';
        let event = 'Details from Overlay Default';
        let hitUrl = hit.url;
        if (hitUrl.includes('/recipes/')) {
          resultType = 'Recipe:';
          event = 'Details from Overlay Recipe';
        }
        else if (hitUrl.includes('/items/')) {
          resultType = 'Product:';
          event = 'Details from Overlay Product';
        }
        else if (hitUrl.includes('/blog/')) {
          resultType = 'Blog:';
        }
        else if (hitUrl.includes('/classes/')) {
          resultType = 'Class:';
        }
        else if (hitUrl.includes('/videos/')) {
          resultType = 'Video:';
        }
        else {
          resultType = 'Page:';

        }
        const option = document.createElement('li', {'role': 'option', 'tabindex': -1});
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
        const link = document.createElement('a');
        link.setAttribute('href', hitUrl);
        link.innerHTML = `<span class="type-indicator">${resultType}</span>${hit.title || hit.name}`;
        link.addEventListener('click', function () {
          sendEvent('click', hit, event);
        });
        option.append(link);
        return option;
      });
  }

  Drupal.theme.num = 0;
  Drupal.theme.lockSearchResultsFocus = (direction, elements) => {
    const input = document.querySelector('.search__overlay .search-input');
    const increment = num => (num >= elements.length - 1 ? 0 : num + 1);
    const decrement = num => (num <= 0 ? elements.length - 1 : num - 1);

    if (elements.length > 0) {
      if (direction === 'ArrowUp') {
        elements[Drupal.theme.num].children[0].focus();
        Drupal.theme.num = decrement(Drupal.theme.num);
      }

      if (direction === 'ArrowDown') {
        elements[Drupal.theme.num].children[0].focus();
        Drupal.theme.num = increment(Drupal.theme.num);
      }
    }
  };

  Drupal.behaviors.searchOverlay = {
    attach(context) {
      if (context !== document) {
        return;
      }

      const searchTrigger = document.querySelector('.search__show');

      if (!searchTrigger) {
        return;
      }

      const overlay = document.querySelector('.search__overlay');
      const input = overlay.querySelector('.search-input');
      const submitButton = overlay.querySelector('.search-submit');
      const closeButton = overlay.querySelector('.search__hide');
      const searchForm = overlay.querySelector('.search__bar');
      const autocomplete = overlay.querySelector('.search-autocomplete');
      const promo = overlay.querySelector('.search_promotion');
      const selectContainer = overlay.querySelector('.select--container');
      const select = selectContainer.querySelector('select');
      const selectDisplay = selectContainer.querySelector('.select-selected');
      const selectDivs = selectContainer.querySelectorAll('.select-items > div');

      let valueByPath = 'rebuild_all_index';

      const classes = {
        open: 'js-search-is-open',
        active: 'is-active',
      };

      /**
       * Initialize Algolia search client.
       */
      const algoliaClient = algoliasearch(
        drupalSettings.kaf_search.algolia_app_id,
        drupalSettings.kaf_search.algolia_api_key
      );

      // Proxy search wrapper so we can avoid empty searches.
      const searchClient = {
        ...algoliaClient,
        search(requests) {
          if (requests.every(({ params }) => !params.query)) {
            // No query; return empty result without pinging Algolia.
            return Promise.resolve({
              results: requests.map(() => ({
                hits: [],
                nbHits: 0,
                nbPages: 0,
                page: 0,
                processingTimeMS: 0,
              })),
            });
          }

          const newRequests = requests.map(request => {
            // Scope empty string and asterisk out of search analytics.
            if (
              !request.params.query ||
              request.params.query.length == 0 ||
              request.params.query == '*'
            ) {
              request.params.analytics = false;
            }
            return request;
          });

          return algoliaClient.search(newRequests);
        },
      };

      const indices = {
        all: { value: Drupal.kafHelper.checkIndex('rebuild_all_index'), label: 'All' },
        recipe: { value: Drupal.kafHelper.checkIndex('recipe_index'), label: 'Recipes' },
        product: { value: 'bc_product_index', label: 'Products' },
        blog: { value: Drupal.kafHelper.checkIndex('blog_index'), label: 'Blogs' },
        classes: { value: Drupal.kafHelper.checkIndex('parent_class_index'), label: 'Classes' },
        other: { value: Drupal.kafHelper.checkIndex('general_content_index'), label: 'Other' },
      };

      const mainIndex = indices.recipe;

      const is = instantsearch({
        indexName: mainIndex.value,
        insights: {},
        searchClient,
      });

      /**
       * Instantiate custom configure widget.
       */
      const customConfigure = instantsearch.connectors.connectConfigure(
        this.renderConfigure,
        () => {}
      );

      /**
       * Instantiate custom autocomplete connector widget.
       */
      const customAutocomplete = instantsearch.connectors.connectAutocomplete(
        this.renderAutocomplete
      );

      is.addWidgets([
        instantsearch.widgets.index({ indexName: indices.product.value }),
        instantsearch.widgets.index({ indexName: indices.blog.value }),
        instantsearch.widgets.index({ indexName: indices.classes.value }),
        instantsearch.widgets.index({ indexName: indices.other.value }),

        customAutocomplete({
          container: autocomplete,
        }),

        customConfigure({
          container: autocomplete,
          searchParameters: {
            hitsPerPage: valueByPath.indexOf('rebuild_all_index') !== -1 ? 1 : 4,
          },
        }),
      ]);

      is.start();

      const lockFocus = () => {
        const overlay = document.querySelector('.search__overlay--inner-container');
        const focusableElements =
          'button, [href], input, textarea, [tabindex]:not([tabindex="-1"]), div.select-selected, div.select-item';
        const firstFocusableElement = overlay.querySelectorAll(focusableElements)[0];
        const focusableContent = overlay.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1];

        document.addEventListener('keydown', e => {
          let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

          if (!isTabPressed) {
            return;
          }

          if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
              lastFocusableElement.focus();
              e.preventDefault();
            }
          } else {
            // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
              firstFocusableElement.focus();
              e.preventDefault();
            }
          }
        });

        firstFocusableElement.focus();
      };

      /**
       * Open the search overlay.
       */
      const openSearch = () => {
        if (!overlay.classList.contains(classes.active)) {
          overlay.classList.add(classes.active);
          searchTrigger.setAttribute('aria-hidden', 'true');
          select.value = valueByPath;
          const selectDisplayElement = document.querySelector(
            '.select-item[data=' + Drupal.kafHelper.checkIndex(valueByPath) + ']'
          );
          if (selectDisplayElement) {
            selectDisplay.textContent = selectDisplayElement.textContent;
          }

          // Need timeout for focus to work properly.
          setTimeout(() => {
            lockFocus();
            input.focus();
          }, 50);
        }
      };

      /**
       * Close the search overlay.
       */
      const searchOverlayClosedEvent = new Event('searchOverlayClosed');
      const closeSearch = () => {
        if (!overlay.classList.contains(classes.active)) {
          return;
        }

        searchTrigger.setAttribute('aria-hidden', 'false');
        searchTrigger.focus();
        input.setAttribute('tabindex', '0');
        overlay.classList.remove(classes.active);
        searchForm.classList.remove(classes.active);
        input.value = '';
        autocomplete.style.display = 'none';
        promo.style.display = 'block';
        selectDivs.forEach(
          item =>
            item.classList.contains('same-as-selected') && item.classList.remove('same-as-selected')
        );
        document.dispatchEvent(searchOverlayClosedEvent);
      };

      searchTrigger.addEventListener('click', openSearch);
      closeButton.addEventListener('click', closeSearch);


      autocomplete.addEventListener('keydown', e => {
        if (e.code === 'Escape') {
          Drupal.theme.num = 0;
          input.focus();
          e.stopPropagation();
        }
      });
      document.addEventListener('keydown', e => {
        if (e.code === 'Escape') {
          closeSearch();
        }
      });

      submitButton.addEventListener('click', e => {
        const select = document.querySelector('.search__bar--select');
        let hash = ``;
        switch (true) {
          case select.value === '':
            // fallthrough
          case select.value.indexOf(Drupal.kafHelper.checkIndex('rebuild_all_index')) !== -1:
            hash = `#${'all_indices'}`;
            break;

          default:
            hash = `#${select.value}`;
            break;
        }

        window.location =
          window.location.origin +
          '/search?query=' +
          encodeURIComponent(input.value.toLowerCase()) +
          hash;
      });

      input.addEventListener('keydown', e => {
        const select = document.querySelector('.search__bar--select');
        let hash = ``;
        switch (true) {
          case select.value.indexOf('rebuild_all_index') !== -1:
            hash = `#${'all_indices'}`;
            break;

          default:
            hash = `#${select.value}`;
            break;
        }
        if (e.code == 'Enter') {
          if (input.value.length > 0) {
            window.location =
              window.location.origin +
              '/search?query=' +
              encodeURIComponent(input.value.toLowerCase()) +
              hash;
          }
        }

        if (e.code === 'ArrowUp') {
          Drupal.theme.lockSearchResultsFocus(e.code, autocomplete.querySelectorAll('ul li'));
        }

        if (e.code === 'ArrowDown') {
          Drupal.theme.lockSearchResultsFocus(e.code, autocomplete.querySelectorAll('ul li'));
        }
      });
    },
    /**
     * Custom Configure widget render function.
     */
    renderConfigure: (renderOptions, isFirstRender) => {
      const { refine } = renderOptions;

      if (isFirstRender) {
        const overlay = document.querySelector('.search__overlay');
        const select = overlay.querySelector('.select-items');
        const realSelect = overlay.querySelector('.search__bar--select');
        let currentIndex;

        const refineResults = event => {
          const selectedElement = event.target;
          const clickedValue = selectedElement.getAttribute('data');
          // If already selected index is clicked again, don't refine.
          if (clickedValue === currentIndex) {
            return;
          }

          currentIndex = selectedElement.getAttribute('data');
          const realSelectValue = realSelect.value;
          const isAllSelected =
            clickedValue.indexOf('rebuild_all_index') !== -1 ||
            realSelectValue.indexOf('rebuild_all_index') !== -1;

          refine({
            hitsPerPage: isAllSelected ? 1 : 4,
          });
        };

        select.addEventListener('click', e => {
          refineResults(e);
        });

        select.addEventListener('keydown', e => {
          if (e.code == 'Enter') {
            refineResults(e);
          }
        });

        document.addEventListener('searchOverlayClosed', function () {
          refine({
            hitsPerPage: 1,
          });
        });
      }
    },

    /**
     * Autocomplete widget render function.
     */
    renderAutocomplete(renderOptions, isFirstRender) {
      const { indices, refine, widgetParams } = renderOptions;
      const { container } = widgetParams;
      const input = document.querySelector('.search__overlay .search-input');
      const promo = document.querySelector('.search_promotion');
      const autoComplete = document.querySelector('.search-autocomplete');
      const indexSelect = document.querySelector('.search__bar--select');

      if (isFirstRender) {
        const searchForm = document.querySelector('.search-input');
        input.addEventListener('input', e => {
          if (e.currentTarget.value.length > 2) {
            refine(e.currentTarget.value);
          }

          if (e.currentTarget.value.length === 0) {
            searchForm.classList.remove('is-active');
          } else {
            searchForm.classList.add('is-active');
          }
        });
      }

      const getIndices = (indices, selectVal) => {
        let updatedIndices;
        if (selectVal !== '') {
          if (selectVal.indexOf('rebuild_all_index') !== -1) {
            updatedIndices = indices;
          } else {
            updatedIndices = indices.filter(({ indexId }) => selectVal.indexOf(indexId) !== -1);
          }
        } else {
          updatedIndices = indices;
        }
        return updatedIndices;
      };

      const ariaAssertive = updatedIndices => {
        const indices = [
          { value: Drupal.kafHelper.checkIndex('rebuild_all_index'), label: 'All' },
          { value: Drupal.kafHelper.checkIndex('recipe_index'), label: 'Recipes' },
          { value: 'bc_product_index', label: 'Products' },
          { value: Drupal.kafHelper.checkIndex('blog_index'), label: 'Blogs' },
          { value: Drupal.kafHelper.checkIndex('parent_class_index'), label: 'Classes' },
          { value: Drupal.kafHelper.checkIndex('general_content_index'), label: 'Other' },
        ];
        const element = document.getElementById('search__overlay--announce');
        let index;

        if (updatedIndices && updatedIndices[0] && updatedIndices[0].indexName) {
          const matchingIndex = indices.find(index =>
            index.value.includes(updatedIndices[0].indexName)
          );
          index = updatedIndices.length > 1 ? `All` : matchingIndex.label;
        }

        let results = 0;
        if (index == 'All') {
          updatedIndices.forEach(e => {
            if (e.hits.length) {
              results++;
            }
          });
        } else {
          results =
            updatedIndices.length > 1 ? updatedIndices.length : updatedIndices[0].hits.length;
        }

        element.innerHTML = `${results} results found in ${index}, to navigate use up and down arrows.`;
      };

      if (input.value.length > 2) {
        autoComplete.style.display = 'block';
        input.setAttribute('aria-expanded', 'true');
        promo.style.display = 'none';
        let updatedIndices;

        if (indexSelect) {
          updatedIndices = getIndices(indices, indexSelect.value);
        } else {
          updatedIndices = indices;
        }

        // Set aria-assertive to anounce results.
        ariaAssertive(updatedIndices);

        const containerList = container.querySelector('ul');
        const containerListItems = container.querySelectorAll('ul li');

        containerList.innerHTML = '';
        let results = updatedIndices
          .map(Drupal.theme.search_autocomplete_results).flat();
        containerList.append(...results);

        // Execute a query here to pick the new html from above.
        containerListItems.forEach(element => {
          element.addEventListener('keydown', e => {
            if (e.code === 'ArrowUp' || e.code === 'ArrowDown') {
              Drupal.theme.lockSearchResultsFocus(e.code, containerListItems);
            }
          });
        });
      } else {
        promo.style.display = 'block';
        autoComplete.style.display = 'none';
        input.setAttribute('aria-expanded', 'false');
      }
    },
  };

  Drupal.behaviors.kafSearchAnalytics = {
    attach(context) {
      if (this.initialized) {
        return;
      }

      if (!drupalSettings.kaf_search.algolia_app_id || !drupalSettings.kaf_search.algolia_api_key) {
        console.log('No Algolia app ID / API key set for search insights.');
        return;
      }

      this.initialized = true;
    },
    initialized: false,
  };
})(Drupal, drupalSettings, algoliasearch, instantsearch);
